import { StepViewModel } from './types/StepViewModel';

export const mockStepsContent: StepViewModel[] = [
  {
    stepNumber: 1,
    title: 'Start vælgererklæring',
    description:
      'Du kan give din støtte til et parti, som du ønsker skal komme på stemmesedlen.',
    image: {
      src: 'https://placehold.co/900x650',
      alt: 'Vælgererklæring',
      width: 900,
      height: 650,
    },
  },
  {
    stepNumber: 2,
    title: 'Vent 7 døgn',
    description:
      'Ventetiden sikrer dig tid til at tænke over, om du ønsker at støtte partiet.',
    image: {
      src: 'https://placehold.co/900x650',
      alt: 'Vælgererklæring',
      width: 900,
      height: 650,
    },
  },
  {
    stepNumber: 3,
    title: 'Bekræft dit valg',
    description:
      'Du får en besked i e-Boks efter de 7 døgn - og kan bekræfte din vælgererklæring med MitID.',
    image: {
      src: 'https://placehold.co/900x650',
      alt: 'Vælgererklæring',
      width: 900,
      height: 650,
    },
  },
];
